<template>
  <i class="tm-row-empty">
    <i class="-visual">
      <i class="-placeholder">
        <i class="wticon wticon-camera2" />
        Add images or video here to create your timeline
      </i>
    </i>

    <template v-if="shouldShow_TrackLayerAudio">
      <i class="-audio">
        <i class="-placeholder"> Add audio here </i>
      </i>
    </template>
  </i>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'tm-row-empty',

  computed: {
    ...mapGetters('timemachine', ['shouldShow_TrackLayerAudio']),
  },
};
</script>

<style lang="scss">
.tm-empty-view > .tm-row-empty {
  display: flex;
  flex-direction: column;
  flex: 0 1 auto;
  align-self: stretch;
  position: relative;
  height: var(--tm-pxRowHeight);
  color: rgba(0, 0, 0, 0.3);

  > .-visual,
  > .-audio {
    display: flex;
    align-items: stretch;
    justify-content: center;
    background-color: var(--tm-audioTrackBackground);
    border: 1px dashed rgba(0, 0, 0, 0.3);

    > .-placeholder {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
    }
  }

  > .-visual {
    margin-top: var(--tm-pxRowBlankTop);
    height: var(--tm-pxAssetHeight);
  }

  > .-audio {
    margin-top: var(--tm-pxTranscriptTrackH);
    height: var(--tm-pxAudioTrackH);
    background-image: url('/resources/js/views/Story/Timeline/view/grid/empty-audio-row.png');
    background-size: auto 20px;
    background-repeat: repeat-x;
    background-position: left center;

    > .-placeholder {
      background-color: #e7e7e7;
      padding: 0 20px;
    }
  }

  .wticon {
    font-size: 20px;
    margin-bottom: 10px;
  }
}
</style>
